import React, {useState, useRef} from 'react';
import {Button, Input, Space, Table, Tag, Skeleton} from 'antd';
import {SearchOutlined, CheckCircleOutlined} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import {Link} from "react-router-dom";
import Title from "../../../components/Title";
import {useSelector} from "react-redux";
import {useGetDriverQuery} from "../../../slices/rootApiSlices/driverApiSlice";
import AddDriverModal from "./addDriverModal";
import moment from "moment";

const Index = () => {

    const {user} = useSelector((state) => state.auth);
    const {data, error, isLoading} = useGetDriverQuery(user?.token);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Ara ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Ara
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Sıfırla
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filtrele
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        kapat
                    </Button>
                </Space>
            </div>
        ),
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: 'İsim',
            dataIndex: 'name',
            key: 'name',
            width: '15%',
            ...getColumnSearchProps('name'),
            render: (text, row) => <Link style={{justifyContent: "center"}} to={`/settings/drivers/${row.id}`}> {text ? text : "no name"} </Link>,
        },
        {
            title: 'Soyisim',
            dataIndex: 'surname',
            key: 'surname',
            width: '10%',
            ...getColumnSearchProps('surname'),
        },
        {
            title: 'Oluşturulma Tarihi',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: '17%',
            responsive: ['sm'],
            ...getColumnSearchProps('createdAt'),
            render: (text) => (
                <span>
                    {moment(text).add(3, 'hours').format('DD-MM-YYYY HH:mm:ss')}
                </span>
            ),
        },
        {
            title: 'Güncelleme Tarihi',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            width: '17%',
            responsive: ['sm'],
            ...getColumnSearchProps('updatedAt'),
            render: (text) => (
                <span>
                    {moment(text).add(3, 'hours').format('DD-MM-YYYY HH:mm:ss')}
                </span>
            ),
        },
        {
            title: 'Durumu',
            key: 'isActive',
            width: '5%',
            responsive: ['lg'],
            dataIndex: 'isActive',
            sorter: (a, b) => a.isActive.length - b.isActive.length,
            render: status => (
                <span style={{textAlign: "center"}}>
                    {
                        status === true ?
                            <Tag style={{padding: 3, paddingInline: 5, textAlign: "center"}}
                                 icon={<CheckCircleOutlined/>} color='green' key={status}>
                                Aktif
                            </Tag>
                            :
                            <Tag color='volcano' key={status}>
                                Servis Dışı
                            </Tag>
                    }
                </span>
            ),
        }
    ];

    let locale = {
        emptyText: 'Sürücü bulunamadı.Lütfen sürücü ekleyin.',
    };

    return (
        <Skeleton loading={isLoading}>
            <div style={{padding: 15}}>
                <Title title="Octoopi Cocpit | Sürücü Listesi" description="Mertech Arge A.Ş Sürücü Listesi"/>
                <AddDriverModal/>
                <Table
                    locale={locale}
                    rowKey="id"
                    loading={isLoading}
                    bordered={true}
                    size="small"
                    columns={columns}
                    dataSource={data ? data?.data : []}
                    error={error}
                />
            </div>
        </Skeleton>
    );
};

export default Index;
